import { getBrowserLocale } from '@/plugins/i18n';
import { computed, reactive } from 'vue';

const STORAGE_KEYS = {
    DARK_THEME: 'app-dark-theme',
    MENU_STATE: 'app-menu-closed',
    LANGUAGE: 'app-language'
};

const layoutConfig = reactive({
    darkTheme: JSON.parse(localStorage.getItem(STORAGE_KEYS.DARK_THEME) || 'false'),
    menuMode: 'static',
    language: localStorage.getItem(STORAGE_KEYS.LANGUAGE) || getBrowserLocale()
});

const layoutState = reactive({
    staticMenuDesktopInactive: JSON.parse(localStorage.getItem(STORAGE_KEYS.MENU_STATE) || 'false'),
    overlayMenuActive: false,
    staticMenuMobileActive: false,
    menuHoverActive: false,
    activeMenuItem: null
});

export function useLayout() {
    const toggleDarkMode = () => {
        if (!document.startViewTransition) {
            executeDarkModeToggle();
            return;
        }
        document.startViewTransition(() => executeDarkModeToggle());
    };

    const executeDarkModeToggle = () => {
        layoutConfig.darkTheme = !layoutConfig.darkTheme;
        localStorage.setItem(STORAGE_KEYS.DARK_THEME, JSON.stringify(layoutConfig.darkTheme));
        document.documentElement.classList.toggle('app-dark', layoutConfig.darkTheme);
    };

    const setLanguage = (lang) => {
        layoutConfig.language = lang;
        localStorage.setItem(STORAGE_KEYS.LANGUAGE, lang);
        // Dispatch evento per sincronizzare tra tab
        window.dispatchEvent(new StorageEvent('storage', {
            key: STORAGE_KEYS.LANGUAGE,
            newValue: lang
        }));
    };

    const toggleMenu = () => {
        if (layoutConfig.menuMode === 'overlay') {
            layoutState.overlayMenuActive = !layoutState.overlayMenuActive;
        }
        if (window.innerWidth > 991) {
            layoutState.staticMenuDesktopInactive = !layoutState.staticMenuDesktopInactive;
            localStorage.setItem(STORAGE_KEYS.MENU_STATE, JSON.stringify(layoutState.staticMenuDesktopInactive));
        } else {
            layoutState.staticMenuMobileActive = !layoutState.staticMenuMobileActive;
        }
    };

    const isSidebarActive = computed(() => layoutState.overlayMenuActive || layoutState.staticMenuMobileActive);
    const isDarkTheme = computed(() => layoutConfig.darkTheme);
    const currentLanguage = computed(() => layoutConfig.language);

    return {
        layoutConfig,
        layoutState,
        isSidebarActive,
        isDarkTheme,
        currentLanguage,
        toggleDarkMode,
        toggleMenu,
        setLanguage
    };
}
